import auth from '@client/components/auth';
import { resolveInfluencerId } from './resolveInfluencerId';

export const canModerateCommunity = (influencerId?: string): boolean => {
  if (auth.isAdministrator() || auth.isModerator()) return true;

  const own = resolveInfluencerId();
  return (
    auth.isInfluencer() &&
    own !== null &&
    resolveInfluencerId(influencerId) === own
  );
};
